const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.833.5H4.167v1.238h3.666V.5zM5.39 8.548H6.61V4.833H5.39v3.715zm4.889-4.086l.916-.867c-.305-.31-.61-.619-.916-.866l-.856.866C8.506 2.852 7.283 2.357 6 2.357 2.944 2.357.5 4.833.5 7.93.5 11.024 2.944 13.5 6 13.5s5.5-2.476 5.5-5.571c0-1.3-.428-2.539-1.222-3.467zM6 12.262c-2.383 0-4.278-1.92-4.278-4.333 0-2.415 1.895-4.334 4.278-4.334 2.383 0 4.278 1.92 4.278 4.334 0 2.414-1.895 4.333-4.278 4.333z",
  fill: "#00244D"
});
function SvgTimer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.6f30ca74.svg";
export { ForwardRef as ReactComponent };